export const API_URLS = {
  SIGNUP: "/pos/register",
  LOGOUT: "/pos/logout",
  CUSTOMER: "/app/v1/pos/customer?is_deleted=false",
  PRODUCT: "/app/v1/pos/product?is_deleted=False",
  ORDER: "/app/pos/v2/order",
  CATEGORY: "/app/v1/pos/category?is_deleted=False",
  STAFF: "/app/pos/v2/staff?is_deleted=false",
  USER: "/pos/v2/add",
  BRANCH: "/app/pos/v2/branch?is_deleted=False",
  LEDGER: "/pos/ledger",
  PROFILE: "/pos/v2/profile",
  PROFILE_IMAGE: "/pos/profile_images",
  THEME: "/pos/v2/theme",
  REPORT: "/app/v2/import_export",
  SEND_EMAIL: "/app/v1/pos/orders_send_email",
};
